(function () {
  function initResumeUpload(root) {
    var input = root.querySelector('[data-warranty-resume-input]');
    var zone = root.querySelector('[data-warranty-resume-zone]');
    var label = root.querySelector('[data-warranty-resume-label]');

    if (!input || !zone) return;

    zone.addEventListener('click', function () {
      input.click();
    });

    zone.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        input.click();
      }
    });

    zone.addEventListener('dragover', function (event) {
      event.preventDefault();
      zone.classList.add('is-dragover');
    });

    zone.addEventListener('dragleave', function () {
      zone.classList.remove('is-dragover');
    });

    zone.addEventListener('drop', function (event) {
      event.preventDefault();
      zone.classList.remove('is-dragover');
      if (event.dataTransfer && event.dataTransfer.files.length) {
        input.files = event.dataTransfer.files;
        updateLabel();
      }
    });

    input.addEventListener('change', updateLabel);

    function updateLabel() {
      if (!label) return;
      if (input.files && input.files.length) {
        label.textContent = input.files[0].name;
      }
    }
  }

  function initJotformWarrantyForm(root) {
    initResumeUpload(root);

    var successMessage = root.querySelector('[data-warranty-form-success]');
    var errorMessage = root.querySelector('[data-warranty-form-error]');
    var submitDateInput = root.querySelector('[data-warranty-submit-date]');
    var spcInput = root.querySelector('[data-warranty-jotform-spc]');
    var formId = root.getAttribute('data-warranty-jotform-id');
    var submitButton = root.querySelector('.rabitat-warranty-register__submit');
    var fileInput = root.querySelector('[data-warranty-resume-input]');
    var externalFields = root.querySelector('[data-warranty-external-fields]');
    var purchaseSources = root.querySelectorAll('[data-warranty-purchase-source]');
    var resumeLabel = root.querySelector('[data-warranty-resume-label]');
    var defaultResumeLabel = resumeLabel ? resumeLabel.textContent.trim() : '';
    var defaultSubmitLabel = submitButton
      ? submitButton.getAttribute('data-warranty-submit-default') || submitButton.textContent.trim()
      : 'Submit';
    var loadingSubmitLabel = submitButton
      ? submitButton.getAttribute('data-warranty-submit-loading') || 'Submitting...'
      : 'Submitting...';
    var iframeName = 'warranty-jotform-target-' + (formId || 'form');
    var iframe = document.createElement('iframe');
    var awaitingResponse = false;
    var responseTimeoutId = 0;

    iframe.name = iframeName;
    iframe.title = 'Form submission';
    iframe.hidden = true;
    iframe.setAttribute('tabindex', '-1');
    iframe.setAttribute('aria-hidden', 'true');
    root.appendChild(iframe);

    function setSubmitting(isSubmitting) {
      if (!submitButton) return;
      submitButton.disabled = isSubmitting;
      submitButton.textContent = isSubmitting ? loadingSubmitLabel : defaultSubmitLabel;
      if (isSubmitting) {
        submitButton.setAttribute('aria-busy', 'true');
      } else {
        submitButton.removeAttribute('aria-busy');
      }
    }

    function hideStatusMessages() {
      if (successMessage) successMessage.hidden = true;
      if (errorMessage) errorMessage.hidden = true;
    }

    function resetSelects() {
      root.querySelectorAll('.rabitat-warranty-register__select').forEach(function (select) {
        select.selectedIndex = 0;
      });
    }

    function getSelectedPurchaseSource() {
      var selected = root.querySelector('[data-warranty-purchase-source]:checked');
      return selected ? selected.value : '';
    }

    function updatePurchaseFields() {
      var source = getSelectedPurchaseSource();
      var isRabitat = source === 'Rabitat.com';
      var showExternal = source !== '' && !isRabitat;

      if (externalFields) {
        externalFields.hidden = !showExternal;
      }

      if (fileInput) {
        if (showExternal) {
          fileInput.setAttribute('required', '');
          fileInput.disabled = false;
        } else {
          fileInput.removeAttribute('required');
          fileInput.value = '';
          fileInput.disabled = true;
        }
      }

      if (resumeLabel && (!fileInput || !fileInput.files || !fileInput.files.length)) {
        resumeLabel.textContent = defaultResumeLabel;
      }
    }

    function showSuccess() {
      setSubmitting(false);
      root.reset();
      resetSelects();
      updatePurchaseFields();
      hideStatusMessages();
      if (successMessage) {
        successMessage.hidden = false;
        successMessage.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }

    function showError() {
      setSubmitting(false);
      hideStatusMessages();
      if (errorMessage) {
        errorMessage.hidden = false;
        errorMessage.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }

    function prepareSubmissionFields() {
      if (submitDateInput) {
        submitDateInput.value = new Date().toISOString();
      }

      if (spcInput && formId) {
        spcInput.value = formId + '-' + formId;
      }

      updatePurchaseFields();
    }

    purchaseSources.forEach(function (source) {
      source.addEventListener('change', updatePurchaseFields);
    });

    updatePurchaseFields();

    iframe.addEventListener('load', function () {
      if (!awaitingResponse) return;

      awaitingResponse = false;
      window.clearTimeout(responseTimeoutId);

      var submissionFailed = false;

      try {
        var doc = iframe.contentDocument || iframe.contentWindow.document;
        var bodyText = doc && doc.body ? doc.body.textContent : '';
        submissionFailed = /request failed|please try again/i.test(bodyText || '');
      } catch (error) {
        submissionFailed = false;
      }

      if (submissionFailed) {
        showError();
        return;
      }

      showSuccess();
    });

    root.addEventListener('submit', function (event) {
      event.preventDefault();
      hideStatusMessages();
      prepareSubmissionFields();
      setSubmitting(true);
      awaitingResponse = true;
      window.clearTimeout(responseTimeoutId);
      responseTimeoutId = window.setTimeout(function () {
        if (!awaitingResponse) return;
        awaitingResponse = false;
        showError();
      }, 30000);

      root.target = iframeName;
      root.submit();
    });
  }

  document.querySelectorAll('[data-warranty-jotform]').forEach(initJotformWarrantyForm);
})();
